export default {"src":"/_next/static/media/logo_light.193d5f66.svg","height":200,"width":600,"blurWidth":0,"blurHeight":0};